<template>
  <div>
    <v-card class="ma-10">
      <v-card-title class="font-weight-light display-1 text-uppercase">
        Partner Summaries
      </v-card-title>

      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="search"
            label="Search ..."
            class="mx-4"
            append-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-select
            :items="timeSelection"
            item-text="text"
            item-value="val"
            v-model="timeSelected"
            outlined
          >
          </v-select>
        </v-col>
      </v-row>
      <v-data-table
        v-if="dataReady"
        :headers="headers"
        :items="summaries"
        :items-per-page="5"
        class="elevation-1"
        id="orgs"
      >
        <template v-slot:item.quantRatio="{ item }">
          <v-chip :color="getColor(item.quantRatio)" dark>{{
            item.quantRatio
          }}</v-chip>
        </template>
        <template v-slot:item.weightRatio="{ item }">
          <v-chip :color="getColor(item.weightRatio)" dark>{{
            item.weightRatio
          }}</v-chip>
        </template>
        <template v-slot:item.controls="props">
          <v-btn
            class="mx-2"
            fab
            dark
            small
            color="pink"
            :to="{ name: 'statsOrgs', query: { id: props.item.ID_Org } }"
          >
            <v-icon dark>fa-chart-line</v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <v-row class="justify-space-between">
        <!-- <v-spacer /> -->
        <v-col cols="4">
          <v-card-title class="font-weight-light">
            Total Partners By Year
          </v-card-title>
          <reactive-line-chart
            :chart-data="partnerLineData.year"
          ></reactive-line-chart>
        </v-col>
        <v-col cols="4">
          <v-card-title class="font-weight-light">
            New Partners by Month in {{ new Date().getFullYear() }}
          </v-card-title>
          <reactive-bar-chart
            :chart-data="partnerLineData.month"
          ></reactive-bar-chart>
        </v-col>
        <v-spacer />
      </v-row>
    </v-card>
    <v-card class="ma-10">
      <v-card-title class="font-weight-light display-1 text-uppercase mt-5">
        Depot Summaries
      </v-card-title>

      <v-row>
        <v-col cols="4">
          <v-card-title class="font-weight-light">
            Weight of Articles By Year (in kg)
          </v-card-title>
          <reactive-bar-chart
            :chart-data="barData.depotYearWeight"
            :options="barOptions"
          ></reactive-bar-chart>
        </v-col>
        <v-col cols="4">
          <v-card-title class="font-weight-light">
            Number of Articles By Year
          </v-card-title>
          <reactive-bar-chart
            :chart-data="barData.depotYearNumber"
            :options="barOptions"
          ></reactive-bar-chart>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="ma-10">
      <v-card-title class="font-weight-light display-1 text-uppercase mt-5">
        Site Summaries
      </v-card-title>

      <v-row>
        <v-col cols="4">
          <v-card-title class="font-weight-light">
            Weight of articles transacted By Year
          </v-card-title>
          <reactive-bar-chart
            :chart-data="barData.siteYearWeight"
            :options="barOptions"
          ></reactive-bar-chart>
        </v-col>
        <v-col cols="4">
          <v-card-title class="font-weight-light">
            Number of articles transacted By Year
          </v-card-title>
          <reactive-bar-chart
            :chart-data="barData.siteYearQuantity"
            :options="barOptions"
          ></reactive-bar-chart>
        </v-col>
      </v-row>
    </v-card>
    <!--  <v-card class="ma-10">
      <v-card-title class="font-weight-light display-1 text-uppercase mt-5">
        Category Summaries
      </v-card-title>

      <v-row>
        <v-col cols="4">
          <v-card-title class="font-weight-light"> Kg By Year </v-card-title>
          <reactive-bar-chart
            :chart-data="chartData"
            :options="barOptions"
          ></reactive-bar-chart>
        </v-col>
        <v-col cols="4">
          <v-card-title class="font-weight-light">
            Quantity By Year
          </v-card-title>
          <reactive-bar-chart
            :chart-data="chartData"
            :options="barOptions"
          ></reactive-bar-chart>
        </v-col>
      </v-row>
    </v-card> -->
  </div>
</template>

<style>
#orgs table thead {
  background: #e57373;
  font-size: 50px !important;
}
</style>
<script>
import ReactiveBarChart from "../components/ReactiveBarChart.vue";
import ReactiveLineChart from "../components/ReactiveLineChart.vue";

export default {
  props: {},
  components: {
    ReactiveBarChart,
    ReactiveLineChart,
  },
  computed: {
    // datasets: null,
    // labels: undefined,
    // barOptions: function () {
    //   var options = {
    //     responsive: true,
    //     cutoutPercentage: 50,
    //     layout: {
    //       margin: { top: 20 },
    //     },
    //     barValueSpacing: 20,
    //     maintainAspectRatio: false,
    //     legend: {
    //       display: true,
    //     },
    //     scales: {
    //       // Shouldn't be an array.
    //       xAxes: [
    //         {
    //           gridLines: {
    //             display: false,
    //           },
    //         },
    //       ],
    //       yAxes: [
    //         {
    //           display: true,
    //           ticks: {
    //             suggestedMin: 0, // minimum will be 0, unless there is a lower value.
    //             // OR //
    //             // beginAtZero: true   // minimum value will be 0.
    //           },
    //           gridLines: {
    //             display: false,
    //           },
    //           position: "left",
    //           type: "linear",
    //           scaleLabel: {
    //             display: true,
    //             labelString: "bla",
    //             beginAtZero: true,
    //           },
    //           //yAxisID: "id1"
    //           id: "id1", // incorrect property name.
    //         },
    //       ],
    //       //}]
    //     },
    //   };
    // return options;
    // },
  },
  methods: {
    loadOrgPage: function (ID) {
      window.location.href = "dash/dist/index.html#/statsOrgs?id=" + ID;
    },
    getColor: function (ratio) {
      if (ratio >= 1) {
        return "green";
      } else {
        return "red";
      }
    },
    async fetchPlatformStats() {
      var self = this;
      // fetch("http://localhost/recuperatheque/platformQuery.php", {
      fetch(this.$store.state.pathDepth + "platformQuery.php", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then(function (response) {
          var r = response.json();
          console.log(response);
          // self.uniqueOrgs = response[1];
          return r;
        })
        .then(function (arrayData) {
          // console.log(arrayData);
          self.platformData = arrayData;
          // console.log(arrayData);
          self.createBarData();
        });
    },
    createBarData: function () {
      // returns the dataset array needed by chartJS barplots
      // depot by year quantity
      let datasets = [
        {
          label: "DepotOut",
          backgroundColor: "rgba(255, 99, 132, 0.8)",
          data: [],
        },
        {
          label: "DepotIn",
          backgroundColor: "rgba(54, 162, 235, 0.8)",
          data: [],
        },
      ];
      var labels = [];
      this.barData = {};
      this.platformData.depotTotalsYear.forEach(function (e) {
        datasets[0].data.push(e.outTotalQuantity);
        datasets[1].data.push(e.inTotalQuantity);
        labels.push(e.yearSold);
      });

      this.datasets = datasets;
      this.barData.depotYearNumber = {
        labels: labels,
        datasets: this.datasets,
      };

      // depot by year weight
      datasets = [
        {
          label: "DepotOut",
          backgroundColor: "rgba(255, 99, 132, 0.8)",
          data: [],
        },
        {
          label: "DepotIn",
          backgroundColor: "rgba(54, 162, 235, 0.8)",
          data: [],
        },
      ];
      labels = [];

      this.platformData.depotTotalsYear.forEach(function (e) {
        datasets[0].data.push(e.outTotalWeight);
        datasets[1].data.push(e.inTotalWeight);
        labels.push(e.yearSold);
      });

      // this.datasets = datasets;
      this.barData.depotYearWeight = {
        labels: labels,
        datasets: datasets,
      };

      // site quantity by year
      datasets = [
        {
          label: "Quantity",
          backgroundColor: "rgba(255, 99, 132, 0.8)",
          data: [],
        },
      ];
      labels = [];

      this.platformData.siteTotalsYear.forEach(function (e) {
        datasets[0].data.push(e.totalQuantity);

        labels.push(e.yearSold);
      });

      this.datasets = datasets;
      this.barData.siteYearQuantity = {
        labels: labels,
        datasets: datasets,
      };
      // site weight by year
      datasets = [
        {
          label: "Weight",
          backgroundColor: "rgba(255, 99, 132, 0.8)",
          data: [],
        },
      ];
      labels = [];

      this.platformData.siteTotalsYear.forEach(function (e) {
        datasets[0].data.push(e.totalWeight);

        labels.push(e.yearSold);
      });

      this.datasets = datasets;
      this.barData.siteYearWeight = {
        labels: labels,
        datasets: datasets,
      };

      // partner line charts
      datasets = [
        {
          label: "Year",
          backgroundColor: "rgba(255, 99, 132, 0.8)",
          data: [],
        },
      ];
      labels = [];
      var sumpartners = 0;
      this.platformData.partnersOverTime.forEach(function (e) {
        sumpartners += parseInt(e.orgCount);
        datasets[0].data.push(sumpartners);

        labels.push(e.yearJoined);
      });
      this.partnerLineData = {};
      this.partnerLineData.year = { datasets: datasets, labels: labels };

      // partner line charts
      datasets = [
        {
          label: "Month",
          backgroundColor: "rgba(255, 99, 132, 0.8)",
          data: new Array(12).fill(0),
        },
      ];
      console.log(datasets);
      labels = [];
      var labels = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      this.platformData.partnersOverMonth.forEach(function (e) {
        datasets[0].data[e.monthJoined] = e.orgCount;
      });
      // this.partnerLineData = {};
      this.partnerLineData.month = { datasets: datasets, labels: labels };
    },

    async fetchOrgStats() {
      var self = this;
      // fetch("http://localhost/recuperatheque/adminPlatformQuery.php", {
      fetch(this.$store.state.pathDepth + "adminPlatformQuery.php", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then(function (response) {
          var r = response.json();
          // self.uniqueOrgs = response[1];
          return r;
        })
        .then(function (arrayData) {
          // console.log(arrayData);
          self.allOrgData = arrayData;

          var cleanData = {};
          var outputArray = [];
          // clean the data and calculate the ratios

          self.allOrgData.forEach((e) => {
            // console.log(e);
            if (!(e.ID_userOrg in cleanData)) {
              if (e.action == "taken") {
                // var ID = e.ID_userOrg;
                // console.log(ID);
                cleanData[e.ID_userOrg] = {
                  ID_Org: e.ID_userOrg,
                  orgName: e.OrgName,
                  quantTaken: e.number,
                  weightTaken: e.weight,
                  quantGiven: 0,
                  weightGiven: 0,
                };
              } else {
                cleanData[e.ID_userOrg] = {
                  ID_Org: e.ID_userOrg,
                  orgName: e.OrgName,
                  quantTaken: 0,
                  weightTaken: 0,
                  quantGiven: e.number,
                  weightGiven: e.weight,
                };
              }
            } else {
              if (e.action == "taken") {
                cleanData[e.ID_userOrg]["quantTaken"] = e.number;
                cleanData[e.ID_userOrg]["weightTaken"] = e.weight;
              } else {
                cleanData[e.ID_userOrg]["quantGiven"] = e.number;
                cleanData[e.ID_userOrg]["weightGiven"] = e.weight;
              }
            }
          });
          Object.keys(cleanData).forEach((key) => {
            var sumObj = cleanData[key];
            sumObj.quantRatio = (sumObj.quantGiven / sumObj.quantTaken).toFixed(
              2
            );
            sumObj.weightRatio = (
              sumObj.weightGiven / sumObj.weightTaken
            ).toFixed(2);
            outputArray.push(sumObj);
          });
          self.summaries = outputArray;
          self.dataReady = true;
        });
    },
  },
  computed: {},
  created: function () {
    var vm = this;
    this.fetchOrgStats();
    this.fetchPlatformStats();
  },

  data() {
    return {
      barOptions: {
        responsive: true,
        cutoutPercentage: 50,
        layout: {
          margin: { top: 20 },
        },
        barValueSpacing: 20,

        maintainAspectRatio: false,
        legend: {
          display: true,
        },
        scales: {
          // Shouldn't be an array.
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                suggestedMin: 0, // minimum will be 0, unless there is a lower value.
                // OR //

                // beginAtZero: true   // minimum value will be 0.
              },
              gridLines: {
                display: false,
              },
              position: "left",
              type: "linear",
              scaleLabel: {
                display: true,
                labelString: "bla",
                beginAtZero: true,
              },
              //yAxisID: "id1"
              id: "id1", // incorrect property name.
            },
          ],
          //}]
        },
      },
      partnerLineData: null,
      chartData: null,
      search: "",
      dataReady: false,
      headers: [
        {
          text: "Organization Name",
          align: "start",
          value: "orgName",
        },
        { text: "Quantity Given", value: "quantGiven" },
        { text: "Quantity Taken", value: "quantTaken" },
        { text: "Quantity Ratio", value: "quantRatio" },
        { text: "Weight Given", value: "weightGiven" },
        { text: "Weight Taken", value: "weightTaken" },
        { text: "Weight Ratio", value: "weightRatio" },
        { text: "", value: "controls", sortable: false },
      ],
      allOrgData: null,
      platformData: null,
      datasets: null,
      summaries: null,
      timeSelected: "all",
      timeSelection: [
        { val: "all", text: "All Time" },
        { val: "2020", text: "2020" },
        { val: "2021", text: "2021" },
        { val: "2022", text: "2022" },
      ],
    };
  },
};
</script>
